import { CxEvent } from '@spartacus/core';

export class GtmGgListingProductSelectEvent extends CxEvent {
  event?: string;
  productId?: string;
  categoryId?: string;
  ecommerce?: {
    currencyCode?: string;
    detail?: {
      products?: {
        name?: string;
        id?: string;
      }[];
    };
  };
  eventCallback?: () => void;
}
